<!-- برنامه ریزی سفرهای پرسنل -->

<ng-container *ngIf="bTrip">

    <!-- هدر -->

    <div class="bg-th-yellow mt-0 container-fluid">

        <div class=" d-flex justify-content-between align-content-center h-35">

            <i class="fa fa-arrow-left text-dark my-auto pointer" [routerLink]="['/']"></i>

            <span class="my-auto f16 fw-bold me-2">

                {{!bPlaning ? 'برنامه ریزی سفرهای پرسنل' : 'برنامه ریزی' }}

            </span>

        </div>

    </div>

    <!-- فرم جستجوی  -->

    <ng-container *ngIf="!bPlaning">

        <div class="container mt-2">

            <form #form="ngForm" (ngSubmit)="searchDriver(form)" class="rtl w-100 row gx-2 gy-2 py-2">

                <div class="position-relative col-12 col-md-4">
        
                    <custom-filter *ngIf="showFilter"

                        [strValue]="searchT_Driver"

                        [strComment]="'strFullName'"
                
                        [stylesArray]="['padding-top: 10px','text-align: start']"
                
                        [str_Placeholder]="'نام خانوادگی راننده را جستجو کنید ...'"
                
                        [lst_Main]="list_OfficialDrivers" 
                
                        [lst_SearchKey]="['strFullName']"
                
                        [isDisabled]="false"
                        
                        (hideOptions)="selectDriver($event)">
            
                    </custom-filter>

                </div>
        
                <div class="col-12 col-md-2">
        
                    <form [formGroup]="dateFilter">
        
                        <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"
        
                            [dateInitValue]="false" [dateFormat]="'jYYYY/jMM/jDD'">
        
                            <input type="text" formControlName="fromDate" placeholder="از تاریخ" class="form-control  " />
        
                        </ng-persian-datepicker>
        
                    </form>
        
                </div>
        
                <div class="col-12 col-md-2">
        
                    <form [formGroup]="dateFilter">
        
                        <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"
        
                            [dateInitValue]="false" [dateFormat]="'jYYYY/jMM/jDD'">
        
                            <input type="text" formControlName="toDate" placeholder="تا تاریخ" class="form-control" />
        
                        </ng-persian-datepicker>
        
                    </form>
        
                </div>
        
                <div class="col-12 col-md-auto d-flex flex-column flex-md-row justify-content-around">
        
                    <button class="col-md-auto col-12 btn btn-primary" type="submit">
        
                        &nbsp; جستجو &nbsp;
        
                    </button>
        
                    <button class="col-md-auto col-12 my-1 mx-md-2 my-md-0 btn  btn-success" type="button"
        
                        [disabled]="servicePlaning.strMobile == '' 
                        
                        || servicePlaning?.strMobile?.length < 11 "
                        
                        (click)="driverPlaning()">
        
                        برنامه ریزی
        
                    </button>
        
                    <button class="col-md-auto col-12 btn btn-danger" type="button" 
                        
                        [disabled]="list_drivers.length == 0"
        
                        (click)="removeSchedule_ByGroup()">
        
                        حذف برنامه ریزی
        
                    </button>                
        
                </div>
        
            </form>

        </div>

    </ng-container>

    <!-- لیست سرویس های راننده -->

    <main *ngIf="!bPlaning" class="container rtl p-2">

        <div class="border border-2 ">

            <div class="col-12 p-3">

                <input type="search" #search 
                
                    (input)="searchBy(search.value)" class="form-control"

                    placeholder="جستجو کنید">

            </div>

            <div class="table-responsive " style="max-height: 77vh;">

                <table class="table table-striped">

                    <thead class="position-sticky top-0 bg-white">

                        <tr class="col-12 text-center">

                            <th class="pointer" (click)="markAllSchedule()"> انتخاب </th>

                            <th> عملیات </th>

                            <th> تاریخ </th>

                            <th> نام روز </th>

                            <th> نام راننده </th>

                            <th> موبایل راننده </th>

                            <th> نام پرسنل </th>

                            <th> موبایل پرسنل </th>

                            <th> حوزه خدمت </th>

                            <th> از منزل </th>

                            <th> اولویت </th>

                            <th> صندلی </th>

                        </tr>

                    </thead>

                    <tbody>

                        <ng-container *ngFor="let item of list_drivers;let i = index;">

                            <tr class="col-12 text-center">

                                <td class="text-center">

                                    <input class="pointer" type="checkbox"
                                        [checked]="isScheduleSelected(item.iDailyServicePlanningPassenger)"
                                        (change)="markSchedule($event.target.checked,item)">

                                </td>

                                <td>

                                    <i class="btn-collapse fa fa-plus-circle mx-2 btn btn-success" title="افزودن"
                                        (click)="addStd_Service(i);"></i>

                                    <i class="fa fa-trash btn btn-danger" title="حدف" (click)="removeService(item)"></i>

                                </td>

                                <td>{{item.strDate | faNum }}</td>

                                <td>{{item.strDayName | faNum}}</td>

                                <td>{{item.strFullName | faNum}}</td>

                                <td>{{item.strDriver_Mobile | faNum}}</td>

                                <td>{{item.strName + ' ' }}{{item.strFamily}}</td>

                                <td>{{item.strMobile | faNum }}</td>

                                <td>{{item.strMobileDomain_strComment}}</td>

                                <!-- <td><input type="checkbox" [checked]="item.bFromHome" class="x"></td> -->

                                <td class="text-center"> {{ item.bFromHome ? '✅' : '❌' }} </td>

                                <td>{{item.tiPriority | faNum}}</td>

                                <td>{{item.strSIte | faNum}}</td>


                            </tr>

                            <tr>

                                <td colspan="12" class="collapse d-none">

                                    <div class="form w-100 row gx-2 pb-3">

                                        <div class="col-5">

                                            <label> نام حوزه خدمت </label>

                                            <input type="search" #selectedSchool class="form-control"
                                                [(ngModel)]="searchT_School" (input)="filterSchool()" />

                                            <ul class="list-group" style="max-height: 200px;overflow: auto;">

                                                <li class="list-group-item pointer" *ngFor="let item of filteredSchools"
                                                    [@fadeAnimation] (click)="getStudent(item,'No')">{{ item.strComment
                                                    }} </li>

                                            </ul>

                                        </div>

                                        <div class="col-5">

                                            <label> نام پرسنل </label>

                                            <input id="std" type="search" class="form-control"
                                                [(ngModel)]="searchT_Student" (input)="filterStudent()" />

                                            <ul *ngIf="bStudentList" class="list-group"
                                                style="max-height: 200px;overflow: auto;">

                                                <li class="list-group-item pointer"
                                                    *ngFor="let item of filteredStudents" [@fadeAnimation]
                                                    (click)="selectStudent(item)">{{item.strPassenger_FullName }}</li>

                                            </ul>


                                        </div>

                                        <div class="col-2 d-flex align-items-end">

                                            <button class="btn btn-success w-100" (click)="submit_stdAdd(item)">

                                                افزودن

                                            </button>

                                        </div>

                                    </div>

                                </td>

                            </tr>

                        </ng-container>

                    </tbody>

                </table>

            </div>

        </div>

    </main>

    <!-- برنامه ریزی  -->

    <main *ngIf="bPlaning" class="container rtl p-2">

        <div dir="rtl" class="form row gx-3 gy-2 px-3">

            <div class="col-12 col-md-6">

                <label> نام حوزه خدمت </label>

                <input type="search"
                    [placeholder]="searchT_School == '' && list_Schools.length == 0 ? 'لطفا اندکی صبر کنید' : ' نام حوزه خدمت را جستجو کنید ' "
                    #selectedSchool class="form-control" [(ngModel)]="searchT_School" (input)="filterSchool()" />

                <ul class="list-group" style="max-height: 200px;overflow: auto;">

                    <li class="list-group-item pointer" *ngFor="let item of filteredSchools" [@fadeAnimation]
                        (click)="getStudent(item);selectedSchool.disabled='true'">

                        {{ item.strComment }}

                    </li>

                </ul>


            </div>

            <div class="col-12 col-md-3">

                <label class="text-start"> تاریخ شروع </label>

                <form [formGroup]="dateFilter">

                    <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"
                        [dateInitValue]="false" [dateFormat]="'jYYYY/jMM/jDD'">

                        <input dir="ltr" type="text" formControlName="start" class="form-control  " />

                    </ng-persian-datepicker>

                </form>

            </div>

            <div class="col-12 col-md-3">

                <label class="text-start"> تاریخ پایان </label>

                <form [formGroup]="dateFilter">

                    <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"
                        [dateInitValue]="false" [dateFormat]="'jYYYY/jMM/jDD'">

                        <input dir="ltr" type="text" formControlName="end" class="form-control  " />

                    </ng-persian-datepicker>

                </form>

            </div>

            <div class="col-12 col-md-2">

                <label class="text-start "> حداقل ساعت شروع </label>

                <div class="input-group clockpicker">

                    <input dir="ltr" type="text" class="form-control " value="06:30" id="sTime">

                    <span class="input-group-addon ">

                        <span class="glyphicon glyphicon-time"></span>

                    </span>

                </div>

            </div>

            <div class="col-12 col-md-2">

                <label class="text-start "> حداکثر ساعت پایان </label>

                <div class="input-group clockpicker">

                    <input dir="ltr" type="text" class="form-control " value="08:00" id="eTime">

                    <span class="input-group-addon ">

                        <span class="glyphicon glyphicon-time"></span>

                    </span>

                </div>

            </div>

            <div class="col-12 col-md-2 mt-4 d-flex justify-content-center align-items-center">

                <input type="checkbox" [(ngModel)]="servicePlaning.bFromHome" name="bFromHome">

                <span class="px-1"> سرویس از منزل </span>

            </div>

            <div class="col-12 col-md-6 mt-4 row gx-2 gy-2 justify-content-end">

                <div class="col-12 col-md-4">

                    <button class="btn btn-success w-100" (click)="getDriverStd()">

                        مسافران راننده

                    </button>

                </div>

                <div class="col-12 col-md-2">

                    <button class="btn btn-primary w-100" (click)="submitService()">

                        ثبت

                    </button>

                </div>

                <div class="col-12 col-md-2">

                    <button class="btn btn-danger w-100" (click)="backTo()"> بازگشت </button>

                </div>

            </div>

            <div class="table-responsive mt-3">

                <table class="table table-striped border border-2" id="Export_Excel">

                    <thead class="position-sticky top-0 bg-white">

                        <tr class="col-12 text-center">

                            <th> عملیات </th>

                            <th> مشخصات پرسنل </th>

                            <th> صندلی </th>

                            <th> اولویت </th>

                            <th> توضیحات </th>

                        </tr>

                    </thead>

                    <tbody>

                        <tr class="col-12 text-center" *ngIf="bAddStudent">

                            <td>

                                <i class="fa fa-floppy-o btn btn-primary mx-2 mb-1 fa-lg" (click)="newService()"></i>

                                <i class="fa fa-times fa-lg btn btn-warning" (click)="bAddStudent = false"></i>

                            </td>

                            <td class="col-3">

                                <div class="col-md-12">

                                    <input type="search" [placeholder]="searchT_Student == '' &&  list_Students.length == 0 && searchT_School.trim() != ''  ? 'لطفا اندکی صبر کنید' : '' "  class="form-control" [(ngModel)]="searchT_Student" (input)="filterStudent()" />

                                    <ul class="list-group" style="max-height: 200px;overflow: auto;">

                                        <li class="list-group-item pointer" *ngFor="let item of filteredStudents"

                                            (click)="mdlService('iPassenger',item.iPassenger,item.strPassenger_FullName ? item.strPassenger_FullName : item.strFullName)"

                                            [@fadeAnimation] (click)="getStudent(item)">
                                            
                                            {{ 
                                            
                                                item.strPassenger_FullName ?
                                                
                                                item.strPassenger_FullName :
                                                
                                                item.strFullName
                                            
                                            }}

                                        </li>

                                    </ul>

                                </div>

                            </td>

                            <td class="col-2">

                                <input type="text" #sit (change)="mdlService('strSIte',sit.value)" class="form-control">

                            </td>

                            <td class="col-1">

                                <input type="number" #tiPriority (change)="mdlService('tiPriority',tiPriority.value)"
                                    [ngModel]="lstPassenger.tiPriority" name="tiPriority" class="form-control">

                            </td>

                            <td>

                                <input type="text" #strComment (change)="mdlService('strComment',strComment.value)"
                                    class="form-control">

                            </td>

                        </tr>

                        <tr class="col-12 text-center" *ngFor="let item of list_tempService;let i = index">

                            <ng-container *ngIf="item?.editMode != true">

                                <td class="col-1">

                                    <i class="fa fa-plus-circle btn btn-success fa-lg" *ngIf="i == 0"
                                        (click)="bAddStudent = true"></i>

                                    <i class="fa fa-trash-o btn btn-danger mx-2 my-1 fa-lg"
                                        (click)="removeStd(item,i)"></i>

                                    <i class="fa fa-pencil-square-o btn btn-primary mx-2 fa-lg"
                                        (click)="editMode(item , i)"></i>

                                </td>

                                <td> {{item.strPassenger_FullName ? item.strPassenger_FullName :
                                    getStdName(item?.iPassenger)}} </td>

                                <td> {{item.strSIte ? item.strSIte : '- - - - -'}} </td>

                                <td> {{item.tiPriority ? item.tiPriority : '- - - - -'}} </td>

                                <td> {{item.strComment ? item.strComment : '- - - - -'}} </td>

                            </ng-container>

                            <ng-container *ngIf="item?.editMode == true">

                                <td class="col-1">

                                    <i class="fa fa-check btn btn-success my-1 fa-lg" (click)="editStudent(i)"></i>

                                    <i class="fa fa-times btn btn-warning mx-2 px-3 fa-lg"
                                        (click)="editMode(item , i)"></i>

                                </td>

                                <td> {{item.strPassenger_FullName ? item.strPassenger_FullName :
                                    getStdName(item?.iPassenger)}} </td>

                                <td> <input type="text" class="form-control" [(ngModel)]="editPassenger.strSIte"> </td>

                                <td> <input type="text" class="form-control" [(ngModel)]="editPassenger.tiPriority">
                                </td>

                                <td> <input type="text" class="form-control" [(ngModel)]="editPassenger.strComment">
                                </td>

                            </ng-container>



                        </tr>

                        <tr class="col-12 text-center" *ngIf="list_tempService.length == 0">

                            <td> <i class="fa fa-plus-circle btn btn-success fa-lg" (click)="bAddStudent = true"></i>
                            </td>

                            <td> - - - - - </td>

                            <td> - - - - - </td>

                            <td> - - - - - </td>

                            <td> - - - - - </td>

                        </tr>

                    </tbody>


                </table>

            </div>

        </div>

    </main>

    <!-- لودینگ -->

    <ng-container *ngIf="isLoading" class="">

        <div class="school_loading">

            <!-- <img src="../../../../assets/Img/taxi-trip.gif" alt="loading"> -->

            <h3> ...لطفا منتظر بمانید </h3>

        </div>

    </ng-container>

</ng-container>

<!-- سرویس های راننده -->

<ng-container *ngIf="!bTrip && !bTripPlaning">

    <!-- هدر  -->

    <div class="bg-th-yellow mt-0 container-fluid">

        <div class=" d-flex justify-content-between align-content-center h-35">

            <i class="fa fa-arrow-left text-dark my-auto pointer" (click)="goBack()"></i>

            <span class="my-auto f16 fw-bold me-2">

                {{!bPlaning ? 'سرویس های راننده' : 'برنامه ریزی' }}

            </span>

        </div>

    </div>

    <!-- فرم جستجوی  -->

    <form *ngIf="!bPlaning" #form="ngForm" (ngSubmit)="searchDriver(form)" class="rtl w-100 row gx-2 gy-2 mt-2 p-2">

        <div class="col-12 col-md-2">

            <input [ngModel]="servicePlaning.strMobile" name="strMobile" #strMobile 
            
                (change)="servicePlaning.strMobile = strMobile.value" 
                
                oninput="this.value=this.value.replace(/[^0-9]/g,'');
                
                if(this.value == ''){this.dir='rtl'};
                
                if(this.value != ''){this.dir='ltr'}" 
                
                class="form-control" placeholder="شماره موبایل ">

        </div>

        <div class="col-12 col-md-2">

            <form [formGroup]="dateFilter">

                <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"
                    [dateInitValue]="false" [dateFormat]="'jYYYY/jMM/jDD'">

                    <input type="text" formControlName="fromDate" placeholder="از تاریخ" class="form-control  " />

                </ng-persian-datepicker>

            </form>

        </div>

        <div class="col-12 col-md-2">

            <form [formGroup]="dateFilter">

                <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"
                    [dateInitValue]="false" [dateFormat]="'jYYYY/jMM/jDD'">

                    <input type="text" formControlName="toDate" placeholder="تا تاریخ" class="form-control  " />

                </ng-persian-datepicker>

            </form>

        </div>

        <div class="col-12 col-md-6 d-flex flex-column flex-md-row justify-content-around">

            <button class="col-md-3 col-12  btn  btn-primary" type="submit">جستجو</button>

            <button class="col-md-3 col-12 my-1 my-md-0 btn  btn-success" type="button"
                [disabled]="strMobile.value == '' || strMobile.length < 11 " (click)="driverPlaning()">

                برنامه ریزی

            </button>

            <button class="col-md-4 col-12 btn btn-danger" type="button" [disabled]="list_drivers.length == 0"
                (click)="removeSchedule_ByGroup()">

                حذف برنامه ریزی

            </button>

        </div>


    </form>

    <!-- لیست سرویس های راننده -->

    <main *ngIf="!bPlaning" class="container rtl p-2">

        <div class="mt-3 border border-2 ">

            <div class="col-12 p-3">

                <input type="search" #search (input)="searchBy(search.value)" class="form-control"
                    placeholder="جستجو کنید">

            </div>

            <div class="table-responsive " style="max-height: 76vh;">

                <table class="table table-striped" id="excel-list">

                    <thead class="position-sticky top-0 bg-white">

                        <tr class="col-12 text-center">

                            <th class="pointer" (click)="markAllSchedule()"> انتخاب </th>

                            <th> عملیات </th>

                            <th> تاریخ </th>

                            <th> شروع </th>

                            <th> پایان </th>

                            <th> نام روز </th>

                            <th> نام راننده </th>

                            <th> موبایل راننده </th>

                            <th> نام پرسنل </th>

                            <th> موبایل پرسنل </th>

                            <th> مدرسه </th>

                            <th> از منزل </th>

                            <th> اولویت </th>

                            <th> صندلی </th>

                        </tr>

                    </thead>

                    <tbody>

                        <ng-container *ngFor="let item of list_drivers;let i = index;">

                            <tr class="col-12 text-center">

                                <td class="text-center">

                                    <input class="pointer" type="checkbox"
                                        [checked]="isScheduleSelected(item.iDailyServicePlanningPassenger)"
                                        (change)="markSchedule($event.target.checked,item)">

                                </td>

                                <td>

                                    <i class="btn-collapse fa fa-plus-circle mx-2 btn btn-success" title="افزودن"
                                        (click)="addStd_Service(i);"></i>

                                    <i class="fa fa-trash btn btn-danger" title="حدف" (click)="removeService(item)"></i>

                                </td>

                                <td>{{item.strDate | faNum }}</td>

                                <td>{{item.strMinTime | faNum }}</td>

                                <td>{{item.strMaxTime | faNum }}</td>

                                <td>{{item.strDayName | faNum}}</td>

                                <td>{{item.strFullName | faNum}}</td>

                                <td>{{item.strDriver_Mobile | faNum}}</td>

                                <td>{{item.strName + ' ' }}{{item.strFamily}}</td>

                                <td>{{item.strMobile | faNum }}</td>

                                <td>{{item.strMobileDomain_strComment}}</td>

                                <!-- <td><input type="checkbox" [checked]="item.bFromHome" class="x"></td> -->

                                <td class="text-center"> {{ item.bFromHome ? '✅' : '❌' }} </td>

                                <td>{{item.tiPriority | faNum}}</td>

                                <td>{{item.strSIte | faNum}}</td>


                            </tr>

                            <tr>

                                <td colspan="12" class="collapse d-none">

                                    <div class="form w-100 row gx-2 pb-3">

                                        <div class="col-5">

                                            <label> نام حوزه خدمت </label>

                                            <input type="search" #selectedSchool class="form-control"
                                                [(ngModel)]="searchT_School" (input)="filterSchool()" />

                                            <ul class="list-group" style="max-height: 200px;overflow: auto;">

                                                <li class="list-group-item pointer" *ngFor="let item of filteredSchools"
                                                    [@fadeAnimation] (click)="getStudent(item,'No')">{{ item.strComment
                                                    }} </li>

                                            </ul>

                                        </div>

                                        <div class="col-5">

                                            <label> نام پرسنل </label>

                                            <input id="std" type="search" class="form-control"
                                                [(ngModel)]="searchT_Student" (input)="filterStudent()" />

                                            <ul *ngIf="bStudentList" class="list-group"
                                                style="max-height: 200px;overflow: auto;">

                                                <li class="list-group-item pointer"
                                                    *ngFor="let item of filteredStudents" [@fadeAnimation]
                                                    (click)="selectStudent(item)">{{item.strPassenger_FullName }}</li>

                                            </ul>


                                        </div>

                                        <div class="col-2 d-flex align-items-end">

                                            <button class="btn btn-success w-100" (click)="submit_stdAdd(item)">

                                                افزودن

                                            </button>

                                        </div>

                                    </div>

                                </td>

                            </tr>

                        </ng-container>

                    </tbody>

                </table>
            </div>

        </div>

    </main>

    <!-- برنامه ریزی  -->

    <main *ngIf="bPlaning" class="container rtl p-2">

        <div dir="rtl" class="form row gx-3 gy-2 px-3">

            <div class="col-12 col-md-6">

                <label> نام مدرسه </label>

                <input type="search"

                    [placeholder]="searchT_School == '' && list_Schools.length == 0 ? 'لطفا اندکی صبر کنید' : ' نام مدرسه را جستجو کنید ' "

                    #selectedSchool class="form-control" 
                    
                    [(ngModel)]="searchT_School" 
                    
                    (input)="filterSchool()" />

                <ul class="list-group" style="max-height: 200px;overflow: auto;">

                    <li class="list-group-item pointer" *ngFor="let item of filteredSchools" [@fadeAnimation]

                        (click)="getStudent(item);selectedSchool.disabled='true'">

                        {{ item.strComment }}

                    </li>

                </ul>


            </div>

            <div class="col-12 col-md-3">

                <label class="text-start"> تاریخ شروع </label>

                <form [formGroup]="dateFilter">

                    <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"
                        [dateInitValue]="false" [dateFormat]="'jYYYY/jMM/jDD'">

                        <input dir="ltr" type="text" formControlName="start" class="form-control  " />

                    </ng-persian-datepicker>

                </form>

            </div>

            <div class="col-12 col-md-3">

                <label class="text-start"> تاریخ پایان </label>

                <form [formGroup]="dateFilter">

                    <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"
                        [dateInitValue]="false" [dateFormat]="'jYYYY/jMM/jDD'">

                        <input dir="ltr" type="text" formControlName="end" class="form-control  " />

                    </ng-persian-datepicker>

                </form>

            </div>

            <div class="col-12 col-md-2">

                <label class="text-start "> حداقل ساعت شروع </label>

                <div class="input-group clockpicker">

                    <input dir="ltr" type="text" class="form-control " value="06:30" id="sTime">

                    <span class="input-group-addon ">

                        <span class="glyphicon glyphicon-time"></span>

                    </span>

                </div>

            </div>

            <div class="col-12 col-md-2">

                <label class="text-start "> حداکثر ساعت پایان </label>

                <div class="input-group clockpicker">

                    <input dir="ltr" type="text" class="form-control " value="08:00" id="eTime">

                    <span class="input-group-addon ">

                        <span class="glyphicon glyphicon-time"></span>

                    </span>

                </div>

            </div>

            <div class="col-12 col-md-2 mt-4 d-flex justify-content-center align-items-center">

                <input type="checkbox" [(ngModel)]="servicePlaning.bFromHome" name="bFromHome">

                <span class="px-1"> سرویس از منزل </span>

            </div>

            <div class="col-12 col-md-6 mt-4 row gx-2 gy-2 justify-content-end">

                <div class="col-12 col-md-4">

                    <button class="btn btn-success w-100" (click)="getDriverStd()">

                        دانش آموزان راننده

                    </button>

                </div>

                <div class="col-12 col-md-2">

                    <button class="btn btn-primary w-100" (click)="submitService()">

                        ثبت

                    </button>

                </div>

                <div class="col-12 col-md-2">

                    <button class="btn btn-danger w-100" (click)="backTo()"> بازگشت </button>

                </div>

            </div>

            <div class="table-responsive mt-3">

                <table class="table table-striped border border-2" id="Export_Excel">

                    <thead class="position-sticky top-0 bg-white">

                        <tr class="col-12 text-center">

                            <th> عملیات </th>

                            <th> نام نام خانوادگی دانش آموز </th>

                            <th> صندلی </th>

                            <th> اولویت </th>

                            <th> توضیحات </th>

                        </tr>

                    </thead>

                    <tbody>

                        <tr class="col-12 text-center" *ngIf="bAddStudent">

                            <td>

                                <i class="fa fa-floppy-o btn btn-primary mx-2 mb-1 fa-lg" (click)="newService()"></i>

                                <i class="fa fa-times fa-lg btn btn-warning" (click)="bAddStudent=false"></i>

                            </td>

                            <td class="col-3">

                                <div class="col-md-12">

                                    <input type="search"

                                        [placeholder]="searchT_Student == '' && list_Students.length == 0 &&
                                        
                                        searchT_School.trim() != '' ? 'لطفا اندکی صبر کنید' :
                                        
                                        ' ابتدا مدرسه را انتخاب کنید ' "

                                        class="form-control" [(ngModel)]="searchT_Student" (input)="filterStudent()" />

                                    <ul class="list-group" style="max-height: 200px;overflow: auto;">

                                        <li class="list-group-item pointer" *ngFor="let item of filteredStudents"

                                            (click)="mdlService('iPassenger',item.iPassenger,item.strFullName)"

                                            [@fadeAnimation] (click)="getStudent(item)">
                                            
                                            {{ item.strFullName }}

                                        </li>

                                    </ul>

                                </div>

                            </td>

                            <td class="col-2">

                                <input type="text" #sit (change)="mdlService('strSIte',sit.value)" class="form-control">

                            </td>

                            <td class="col-1">

                                <input type="number" #tiPriority (change)="mdlService('tiPriority',tiPriority.value)"
                                    [ngModel]="lstPassenger.tiPriority" name="tiPriority" class="form-control">

                            </td>

                            <td>

                                <input type="text" #strComment (change)="mdlService('strComment',strComment.value)"
                                    class="form-control">

                            </td>

                        </tr>

                        <tr class="col-12 text-center" *ngFor="let item of list_tempService;let i = index">

                            <ng-container *ngIf="item?.editMode != true">

                                <td class="col-1">

                                    <i class="fa fa-plus-circle btn btn-success fa-lg" *ngIf="i == 0"
                                        (click)="bAddStudent = true"></i>

                                    <i class="fa fa-trash-o btn btn-danger mx-2 my-1 fa-lg"
                                        (click)="removeStd(item,i)"></i>

                                    <i class="fa fa-pencil-square-o btn btn-primary mx-2 fa-lg"
                                        (click)="editMode(item , i)"></i>

                                </td>

                                <td class=""> 

                                    {{ 
                                    
                                        item.strFullName ? item.strFullName :
                                        
                                        item.strPassenger_FullName ? item.strPassenger_FullName :
                                        
                                        getStdName(item?.iPassenger) 
                                    
                                    }} 
                                    
                                </td>

                                <td> {{item.strSIte ? item.strSIte : '- - - - -'}} </td>

                                <td> {{item.tiPriority ? item.tiPriority : '- - - - -'}} </td>

                                <td> {{item.strComment ? item.strComment : '- - - - -'}} </td>

                            </ng-container>

                            <ng-container *ngIf="item?.editMode == true">

                                <td class="col-1">

                                    <i class="fa fa-check btn btn-success my-1 fa-lg" (click)="editStudent(i)"></i>

                                    <i class="fa fa-times btn btn-warning mx-2 px-3 fa-lg"
                                        (click)="editMode(item , i)"></i>

                                </td>

                                <td> {{item.strFullName ? item.strFullName :
                                    getStdName(item?.iPassenger)}} </td>

                                <td> <input type="text" class="form-control" [(ngModel)]="editPassenger.strSIte"> </td>

                                <td> <input type="text" class="form-control" [(ngModel)]="editPassenger.tiPriority">
                                </td>

                                <td> <input type="text" class="form-control" [(ngModel)]="editPassenger.strComment">
                                </td>

                            </ng-container>



                        </tr>

                        <tr class="col-12 text-center" *ngIf="list_tempService.length == 0">

                            <td> <i class="fa fa-plus-circle btn btn-success fa-lg" (click)="bAddStudent = true"></i>
                            </td>

                            <td> - - - - - </td>

                            <td> - - - - - </td>

                            <td> - - - - - </td>

                            <td> - - - - - </td>

                        </tr>

                    </tbody>


                </table>

            </div>

        </div>

    </main>

    <!-- لودینگ سرویس های راننده -->

    <ng-container *ngIf="isLoading" class="">

        <div class="school_loading">

            <img src="../../../../assets/Img/school_2.gif" alt="loading">

        </div>

    </ng-container>

</ng-container>

<!-- سفرهای برنامه ریزی شده -->

<ng-container *ngIf="bTripPlaning">

        <!-- هدر -->

        <div class="bg-th-yellow mt-0 container-fluid">

            <div class=" d-flex justify-content-between align-content-center h-35">
    
                <i class="fa fa-arrow-left text-dark my-auto pointer" [routerLink]="['/']"></i>
    
                <span class="my-auto f16 fw-bold me-2">
    
                    عملکرد سفرهای برنامه ریزی شده
    
                </span>
    
            </div>
    
        </div>
    
        <!-- فرم جستجوی  -->
    
        <form #form="ngForm" (ngSubmit)="searchDriver(form)" class="rtl w-100 row gx-2 gy-2 mt-2 p-2">
    
            <div class="col-12 col-md-2">
    
                <input ngModel name="strMobile" #strMobile (change)="servicePlaning.strMobile = strMobile.value" oninput="this.value=this.value.replace(/[^0-9]/g,'');
                    
                    if(this.value == ''){this.dir='rtl'};
                    
                    if(this.value != ''){this.dir='ltr'}" 
                    
                    class="form-control" placeholder="شماره موبایل ">
    
            </div>
    
            <div class="col-12 col-md-2">
    
                <form [formGroup]="dateFilter">
    
                    <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"
                        [dateInitValue]="false" [dateFormat]="'jYYYY/jMM/jDD'">
    
                        <input type="text" formControlName="fromDate" placeholder="از تاریخ" class="form-control  " />
    
                    </ng-persian-datepicker>
    
                </form>
    
            </div>
    
            <div class="col-12 col-md-2">
    
                <form [formGroup]="dateFilter">
    
                    <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"
                        [dateInitValue]="false" [dateFormat]="'jYYYY/jMM/jDD'">
    
                        <input type="text" formControlName="toDate" placeholder="تا تاریخ" class="form-control  " />
    
                    </ng-persian-datepicker>
    
                </form>
    
            </div>

            <div class="col-12 col-md-1 d-flex align-items-center">
    
                <button class="w-100 btn btn-primary" type="submit">جستجو</button>

            </div>

            <div class="col-12 col-md-auto d-flex align-items-center">
    
                <button class="w-100 btn btn-success" type="button" (click)="exportexcel('excel-list')"> خروجی اکسل </button>

            </div>
        
        </form>
    
        <!-- لیست سفرهای برنامه ریزی شده -->
    
        <main *ngIf="!bPlaning" class="rtl p-2">
    
            <div class="mt-3 border border-2 ">
    
                <div class="col-12 p-3">
    
                    <input type="search" #search (input)="searchBy(search.value)"
                    
                        class="form-control" placeholder="جستجو کنید">
    
                </div>

                <div class="section" style="max-height: 77vh;">
    
                    <table class="table table-striped bg-white mt-1 dirI" id="excel-list">
                
                        <thead>
                
                            <tr class="text-center">
                
                                <th scope="col"># </th>
                
                                <th> تاریخ </th>

                                <th> ساعت سوار شدن </th>

                                <th> ساعت پایان </th>
    
                                <th> نام روز </th>
    
                                <th> نام راننده </th>
    
                                <th> موبایل راننده </th>
    
                                <th> نام پرسنل </th>
    
                                <th> موبایل پرسنل </th>
    
                                <th> حوزه خدمت </th>
    
                                <th> وضعیت انجام </th>

                                <th> وضعیت حضور </th>

                                <th> از منزل </th>
    
                                <th> اولویت </th>
    
                                <th> صندلی </th>
                
                            </tr>
                
                        </thead>
                
                        <tbody>
                
                            <tr *ngFor="let item of list_drivers;let i = index;" class="col-12 text-center">
    
                                <th>{{ i + 1 | faNum }}</th>

                                <td>{{item.strDate | faNum }}</td>
                                
                                <td>{{item.strGettingOnTime | faNum }}</td>
                                
                                <td>{{item.strGettingOffTime | faNum }}</td>

                                <td>{{item.strDayName | faNum}}</td>

                                <td>{{item.strFullName | faNum}}</td>

                                <td>{{item.strDriver_Mobile | faNum}}</td>

                                <td>{{item.strName + ' ' }}{{item.strFamily}}</td>

                                <td>{{item.strMobile | faNum }}</td>

                                <td>{{item.strMobileDomain_strComment}}</td>
                                
                                <td>{{item.strRun}}</td>
                                
                                <td>

                                    <span [ngClass]="item.bAbsence ? 'text-danger fw-bold p-1 px-2 f14 rounded' :
                                    
                                          'text-success fw-bold f14 p-1 px-2 rounded' " 
                                    
                                          [ngStyle]="{'background-color': item.bAbsence ? '#ffe4e6' : '#dcfce7' }">

                                          {{item.bAbsence  ? 'غایب' : 'حاضر' }}

                                    </span>

                                </td>

                                <td class="text-center"> {{ item.bFromHome ? '✅' : '❌' }} </td>

                                <td>{{item.tiPriority | faNum}}</td>

                                <td>{{item.strSIte | faNum}}</td>

                            </tr>
                
                        </tbody>
                
                    </table>
                
                </div>
    
            </div>
    
        </main>
        
        <!-- لودینگ -->
    
        <ng-container *ngIf="isLoading" class="">
    
            <div class="school_loading">
    
                <!-- <img src="../../../../assets/Img/taxi-trip.gif" alt="loading"> -->
    
                <h3> ...لطفا منتظر بمانید </h3>
    
            </div>
    
        </ng-container>

</ng-container>